export default [
  {
    title: 'dashboard',
    icon: 'HomeIcon',
    route: 'dashboard',
    visible: true,
    role: ['BACKOFFICE', 'COMPANY'],
  },
  {
    title: 'companies',
    icon: 'UserIcon',
    route: 'companies',
    visible: true,
    role: ['BACKOFFICE'],
  },
  {
    title: 'usuarios',
    icon: 'UserIcon',
    route: 'users',
    visible: true,
    role: ['BACKOFFICE'],
  },
]
